$(document).on('ready', function () {

    let Flickity = window.Flickity;
    let elem = document.getElementById('sciencetab-carousel');
    let width = $(window).width();
    let align = 'center';
    if (width > 992) {
        align = 'left';
    }
    let flkty = new Flickity(elem, {
        // options
        cellAlign: align,
        contains: false,
        freeScroll: false,
        prevNextButtons: false,
        pageDots: true,
        percentPosition: true
    });

    // Reinitialize carousel on resize with proper height calculation
    let resizeTimeout;
    let lastWidth = width;

    function reinitCarousel() {
        let currentWidth = $(window).width();
        let newAlign = currentWidth > 992 ? 'left' : 'center';

        // Check if we crossed the 992px breakpoint
        let crossedBreakpoint = (lastWidth <= 992 && currentWidth > 992) || (lastWidth > 992 && currentWidth <= 992);
        lastWidth = currentWidth;

        if (crossedBreakpoint && flkty) {
            // Destroy and reinitialize carousel with correct alignment
            flkty.destroy();
            flkty = new Flickity(elem, {
                cellAlign: newAlign,
                contains: false,
                freeScroll: false,
                prevNextButtons: false,
                pageDots: true,
                percentPosition: true
            });
        }
    }

    window.addEventListener('resize', function() {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(function() {
            reinitCarousel();
        }, 250);
    });

    // products adding
    // $(document).on('click', '.toggle-icon', function () {
    //     $(this).toggleClass('item-added');
    // });
});


// Step By Step

$(document).on('ready', function () {

    var Flickity = window.Flickity;
    let elem = document.getElementById('step-carousel');
    let width = $(window).width();
    let align = 'center';
    if (width > 992) {
        align = 'left';
    }
    let flkty = new Flickity(elem, {
        // options
        cellAlign: align,
        contains: false,
        freeScroll: false,
        prevNextButtons: false,
        pageDots: true,
        percentPosition: true
    });




    let maxHeight = 0;

    // Loop through all elements with class "numbers"
    $(document).find('.numbers').each(function () {
        let thisHeight = $(this).height();
        if (thisHeight > maxHeight) {
            maxHeight = thisHeight; // update maxHeight if this element is taller
        }
    });

    // Set all elements with class "numbers" to the tallest height
    $(document).find('.numbers').height(maxHeight);
    setTimeout(function () {
        $(document).find('.numbers').height(maxHeight);
    }, 200);

});